import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const OPTIONS_STORE_PRE_SALE_LOCKS = {
  ACTIONS: {
    SET_LOCKS: 'preSaleLocks/setLocks',
    REMOVE_LOCK: 'preSaleLocks/removeLock'
  },
  GETTERS: {
    GET_LOCKS: 'preSaleLocks/getLocks',
    GET_LOCK_BY_ID: 'preSaleLocks/getLockById',
    IS_LOCKED_BY_ANOTHER: 'preSaleLocks/isLockedByAnother'
  }
};

export default {
  namespaced: true,
  state: {
    locks: {}
  },
  actions,
  getters,
  mutations
};
